import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.182 0v8.182H0v1.636h8.182V18h1.636V9.818H18V8.182H9.818V0Z", className: "s492a523ec7a55c46f310fc5599f86c78__a" }));
const ForwardRef = forwardRef(SvgPlus);
export { ForwardRef as ReactComponent };
